
const ENVIRONMENT           = VULSEEK_ENVIRONMENT; // global variable defined in /js/env.js
const ANALYTICS_KEY         = VULSEEK_ANALYTICS_KEY; // global variable defined in /js/env.js
const GOOGLE_TAG_MANAGER_ID = VULSEEK_GOOGLE_TAG_MANAGER_ID; // global variable defined in /js/env.js

if (ENVIRONMENT === "production") {

    (function(w,d,s,l,i){
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start':new Date().getTime(),
            event:'gtm.js'
        });
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:''
        ;

        j.async=true;
        j.defer=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', "GTM-WP4P98PR");
}
